import './PollingRefresh.scss';

export { default } from './PollingRefresh';
